<template>
    <v-layout class="ma-3" row wrap>
        <v-flex xs6>
            <v-select v-model="status"
                      :items="['PENDING','PROCESSING','SOLVED']"
                      :label="$t('ticketingPage.ticketStatus')"
            />
        </v-flex>
        <v-flex xs6>
            <v-select v-model="ticketTypes"
                      :items="allTicketsTypes"
                      :label="$t('ticketingPage.ticketsTypes')"
                      multiple
                      item-text="title"
                      item-value="id"
                      single-line
                      chips
            />
        </v-flex>
        <v-flex xs12>
            <data-table :url="api.ACTIONS.TICKETS"
                        :initial-url-search-params="params"
                        :enable-add="false"
                        :enable-delete="false"
                        :enable-edit="false"
                        :fields-hidden-main="['author_type','author_id','subject_type','subject_id','data','type_id','user_id','deleted_at']"
                        :formatter="formatter"
                        disable-search
                        :actions-extra-main="actionsExtraMain"
            />

        </v-flex>
    </v-layout>
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";

    export default {
        name: "tickets-monitoring",
        components: {DataTable},
        title() {
            return this.$t("ticketingPage.monitoringTitle");
        },
        data() {
            return {
                status: "PROCESSING",
                ticketTypes: Object.values(this.$store.state.user.settings.ALLOWED_TICKETS)
            }
        },
        computed: {
            actionsExtraMain() {
                const self = this;
                return {
                    viewTicket: {
                        title: self.$t("ticketingPage.viewTicket"),
                        color: "primary",
                        action: (item) => {
                            let routeData = this.$router.resolve({name: 'Ticket', params: {id: item.id}});
                            window.open(routeData.href, '_blank');
                        }
                    }
                }
            },
            params() {
                const params = new URLSearchParams();
                params.append("status", this.status);
                for (let id of this.ticketTypes)
                    params.append("selected_ticket_types[]", id);
                return params;
            },
            allTicketsTypes() {
                const keys = Object.keys(this.$store.state.user.settings.ALLOWED_TICKETS);
                const data = [];
                for (const key of keys) {
                    data.push(
                        {
                            id: this.$store.state.user.settings.ALLOWED_TICKETS[key],
                            title: key
                        }
                    )
                }
                return data;
            },
            formatter() {
                const self = this;
                return {
                    type(type) {
                        return type.title;
                    },
                    subject(subject, item) {
                        if (!subject)
                            return self.$t("ticketingPage.empty");
                        else {
                            let subjectType = item.subject_type.split("\\");
                            subjectType = subjectType[subjectType.length - 1];
                            return `${subjectType} #${subject.id} ${subject.first_name ? subject.first_name + ' ' + subject.last_name : ''}`
                        }
                    },
                    author(author, item) {
                        if (!author)
                            return self.$t("ticketingPage.empty");
                        else {
                            let authorType = item.author_type.split("\\");
                            authorType = authorType[authorType.length - 1];
                            return `${authorType} #${author.id} ${author.first_name ? author.first_name + ' ' + author.last_name : ''}`
                        }
                    },
                    user(user) {
                        if (!user)
                            return self.$t("ticketingPage.na");
                        else
                            return user.first_name + " " + user.last_name;
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
